<template>
  <address class="smart-address" data-type="default">
    <a @click="handleAddressClick">
      <p>{{address.address1}}</p>
      <p>{{address.address2}}</p>
    </a>
  </address>
</template>

<script>
import { address } from '@/data/snippets/companyInfo';
import device from 'current-device';

export default {

  name: 'SmartAddress',

  data() {
    return {
      address,
    };
  },

  computed: {

    mapUrl() {
      const { latitude, longitude } = address;
      if (device.ios()) {
        return `maps://maps.google.com/maps?daddr=${latitude},${longitude}&ll=`;
      }
      return `https://maps.google.com/maps?daddr=${latitude},${longitude}&ll=`;
    },

  },

  methods: {

    handleAddressClick() {
      window.open(this.mapUrl);
    },

  },

};
</script>

<style lang="scss" scoped>
@import '~@/styles/_typography.scss';

.smart-address {
  width: 100%;

  // media query props
  margin-bottom: rem(30px);

  @include ngMq($nbp--tablet, up) {
    margin-bottom: rem(50px);
  }

  a {
    color: $color--primary-midtone;

    p {
      margin-bottom: 0;

      // media query props
      @include sansserif( $size: (16, 22, 0), $weight: 'light');
      line-height: rem(22px);

      @include ngMq($nbp--tablet, up) {
        @include sansserif( $size: (16, 32, 0), $weight: 'light');
        line-height: rem(32px);
      }

      @include ngMq($nbp--desktop, up) {
        @include sansserif( $size: (16, 32, 0), $weight: 'light');
        line-height: rem(32px);
      }
      // @include ngMq($nbp--desktop, up) {
      //   @include sansserif( $size: (16, 32, 0), $weight: 'light');
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SmartAddress.vue